<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <label>{{ $t('common_words.farm') }}</label>
            <br />
            <el-select
              clearable
              @change="hideView"
              filterable
              class="select-primary custom-width-select shadow-sm farm-form"
              size="large"
              v-model="leafForm.farm_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
            <br class="media-none" />
            <label>{{ $t('common_words.date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              @change="hideView"
              :picker-options="pickerOptions"
              class="shadow-sm date-form"
              v-model="leafForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-6 col-md-4 col-lg-4 col-xl-6">
            <label class="label-primary" style="color: transparent">{{
              $t('common_words.generate')
            }}</label
            ><br />
            <button
              style="margin-right: 10px"
              class="btn btn-info btn-fg"
              @click.prevent="generate"
            >
              <i class="fa fa-list-alt"></i> {{ $t('common_words.generate') }}
            </button>
            <button class="btn btn-info btn-fg" @click.prevent="preload">
              <i class="fa fa-table"></i> {{ $t('common_words.preload') }}
            </button>
          </div>
        </div>
        <br />
      </card>
      <card class="custom-shadow-card-header" v-if="showPreload">
        <form>
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <div class="form-group has-label">
                  <el-upload
                    drag
                    ref="upload"
                    :action="getAxiosURL() + '/auth/leafs/leafs/preload'"
                    :data="{ farm_id: leafForm.farm_id, date: formatDate }"
                    :headers="headerInfo"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :auto-upload="false"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      {{ $t('common_words.finished_format') }}
                      <em>{{ $t('common_words.click_to_load') }}</em>
                    </div>
                    <div slot="tip" class="el-upload__tip">
                      {{ $t('common_words.xlsx_notice') }}
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-center" v-if="isCreate()">
                <button
                  style="margin-right: 10px"
                  class="btn btn-info btn-fg"
                  @click.prevent="downloadFormat"
                >
                  <i class="fa fa-file-excel-o"></i>
                  {{ $t('common_words.download_file') }}
                </button>
                <button
                  class="btn btn-info btn-fg"
                  @click.prevent="submitUpload"
                >
                  <i class="fa fa-plus"></i> {{ $t('common_words.load_file') }}
                </button>
              </div>
            </div>
          </div>
        </form>
        <br />
      </card>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="showTable"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table class="table table-striped table-bordered not-last-td">
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th scope="col" class="text-center p-3 custom-header-label">
                      {{ $t('common_words.allotment') }}
                    </th>
                    <th
                      scope="col"
                      v-for="(row, i) in leafForm.nutrientColumns"
                      class="text-center p-3 custom-header-label"
                      :key="i"
                    >
                      {{ row.label }}
                    </th>
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                    ></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(p, i) in leafForm.nLeaf" :key="i">
                    <td class="text-center" style="min-width: 200px">
                      <el-select
                        clearable
                        @clear="clearLotSelect(i)"
                        filterable
                        style="width: 70%; margin: auto"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="large"
                        v-model="leafForm.lots_sel[i]"
                        @change="changeArray(i)"
                        :placeholder="`${$t('common_words.select')}...`"
                      >
                        <el-option
                          v-for="l in availableLots"
                          class="select-primary"
                          :value="l.id"
                          :label="l.name"
                          :key="l.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td
                      v-for="(column, index) in leafForm.nutrientColumns"
                      class="text-center"
                      style="min-width: 100px"
                      :key="index"
                    >
                      <el-input
                        type="number"
                        min="0"
                        max="9999"
                        style="width: 100px"
                        class="shadow-sm text-center required-inputs"
                        :class="
                          column.type == 'Textura' ? 'required-textures' : ''
                        "
                        pattern="/^-?\d+\.?\d*$/"
                        onKeyPress="if(this.value.length==4) return false;"
                        :disabled="disables[i]"
                        v-model="
                          leafForm.inputs[
                            leafForm.lots_sel[i] + '-' + column.prop
                          ]
                        "
                      />
                    </td>
                    <td
                      class="text-center vertical-custom"
                      style="display: table-cell"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate() && leafForm.nLeaf < lots.length"
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click="addRowTable(i)"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="leafForm.nLeaf > 1 && isDelete()"
                          vv-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(leafForm.lots_sel[i], i)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-12 mt-5">
              <div class="row">
                <div class="col-6 text-right">
                  <button
                    class="btn btn-fill btn-info btn-wd shadow-sm"
                    @click="validateForm"
                  >
                    {{ $t('common_words.save_data') }}
                  </button>
                </div>
                <div class="col-6">
                  <button
                    class="btn btn-fill btn-danger btn-wd shadow-sm"
                    @click="DeleteAll"
                  >
                    {{ $t('common_words.delete') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { MixinExport } from 'src/mixins/mixin-export';
import MixinForm from 'src/mixins/forms/mixin-form';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      leafForm: {
        farm_id: null,
        date: moment().format('YYYY-MM-DD'),
        nLeaf: 1,
        lots_sel: [],
        inputs: {},
        inputs_bck: {},
        user_id: this.$store.state.auth.user.id,
      },
      old_lots_sel: [],
      totals: {},
      tableWeekColumns: [],
      showTable: false,
      showPreload: false,
      farms: null,
      disables: [],
      lots: null,
      firstColumn: null,
      secondColum: null,
      firstElement: null,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      fileList: [],
    };
  },

  computed: {
    availableLots() {
      return this.lots.filter(
        (lot) => !this.leafForm.lots_sel.includes(lot.id)
      );
    },

    formatDate() {
      return moment(this.leafForm.date).format('YYYY-MM-DD');
    },
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinNotification,
    MixinExport,
    MixinForm,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    clearLotSelect(index) {
      this.leafForm.lots_sel[index] = null;
      this.disables[index] = true;
    },

    changeArray(index) {
      if (typeof this.old_lots_sel[index] !== 'undefined') {
        for (const key in this.leafForm.inputs) {
          let split = key.split('-');
          if (split[0] == this.old_lots_sel[index]) {
            this.$set(
              this.leafForm.inputs,
              this.leafForm.lots_sel[index] + '-' + split[1],
              this.leafForm.inputs[key]
            );
            delete this.leafForm.inputs[split[0] + '-' + split[1]];
          }
        }

        delete this.totals[this.old_lots_sel[index]];
      }

      if (
        this.leafForm.lots_sel[index] != null &&
        this.leafForm.lots_sel[index] != null
      ) {
        this.disables[index] = false;
      }

      this.old_lots_sel = Object.assign([], this.leafForm.lots_sel);
    },

    addRowTable(index) {
      this.leafForm.nLeaf++;
      this.disables[this.leafForm.nLeaf - 1] = true;
      this.disables['undefined'] = true;
    },

    hideView() {
      this.showTable = false;
      this.showPreload = false;
    },

    cleanView() {
      this.leafForm.lots_sel = [];
      this.leafForm.inputs = {};
      this.leafForm.inputs_bck = {};
      this.leafForm.inputs_ids = {};
      this.tableWeekColumns = [];
      this.disables = [];
      this.totals = {};
    },

    validateFilter() {
      this.leafForm.id = null;

      if (this.leafForm.farm_id == null) {
        this.highlightItem('farm-form');
        return false;
      } else if (this.leafForm.date == null) {
        this.highlightItem('date-form');
        return false;
      } else {
        return true;
      }
    },

    generate() {
      this.cleanView();
      this.leafForm.id = null;

      if (this.validateFilter()) {
        this.showHideLoading(true);

        this.leafForm.route = 'leafs/leafs';
        //this.leafForm.date = moment(this.leafForm.date).format("YYYY-MM-DD"),

        Axios.getMasters('lots/' + this.leafForm.farm_id)
          .then((r1) => {
            Axios.saveMaster(this.leafForm)
              .then((r2) => {
                this.lots = r1.data.data;
                this.leafForm.nLeaf = r2.data.nLeaf;
                this.leafForm.nutrientColumns = r2.data.nutrientColumns;

                if (typeof r2.data.id !== 'undefined') {
                  this.leafForm.id = r2.data.id;
                } else {
                  this.disables[0] = true;
                }

                if (r2.data.lots_sel.length > 0) {
                  this.leafForm.lots_sel = r2.data.lots_sel;
                  this.leafForm.lots_sel_bck = Object.assign(
                    [],
                    this.leafForm.lots_sel
                  );
                  this.old_lots_sel = Object.assign([], this.leafForm.lots_sel);

                  try {
                    this.leafForm.lots_sel = [];
                    setTimeout(() => {
                      this.leafForm.lots_sel = Object.assign(
                        [],
                        this.leafForm.lots_sel_bck
                      );
                    }, 5);
                  } catch (error) {}
                } else {
                  this.disables['undefined'] = true;
                }

                if (Object.keys(r2.data.inputs).length) {
                  this.leafForm.inputs = r2.data.inputs;
                  this.leafForm.inputs_bck = Object.assign(
                    {},
                    this.leafForm.inputs
                  );
                  this.leafForm.inputs_ids = r2.data.inputs_ids;
                }

                this.showTable = true;
                this.showPreload = false;
                this.showHideLoading();
              })
              .catch((error) => console.log(error));
          })
          .catch((error) => console.log(error));
      }
    },

    preload() {
      this.cleanView();
      this.leafForm.id = null;

      if (this.validateFilter()) {
        this.showTable = false;
        this.showPreload = true;
      }
    },

    handleDelete(index, i) {
      if (typeof index !== 'undefined' && index != null) {
        try {
          let index1 = this.leafForm.lots_sel.findIndex((lot) => lot === index);

          this.leafForm.lots_sel.splice(index1, 1);
          delete this.totals[index];

          let tmp = Object.assign([], this.leafForm.lots_sel);
          this.leafForm.lots_sel = [];
          setTimeout(() => {
            this.leafForm.lots_sel = Object.assign([], tmp);
            this.old_lots_sel = Object.assign([], tmp);
          }, 5);
        } catch (error) {}

        try {
          for (const key in this.leafForm.inputs) {
            let split = key.split('-');

            if (split[0] == index) {
              delete this.leafForm.inputs[key];
            }
          }
        } catch (error) {}
      } else {
        try {
          this.leafForm.lots_sel.splice(i, 1);

          let tmp = Object.assign([], this.leafForm.lots_sel);
          this.leafForm.lots_sel = [];
          setTimeout(() => {
            this.leafForm.lots_sel = Object.assign([], tmp);
            this.old_lots_sel = Object.assign([], tmp);
          }, 5);
        } catch (error) {}

        try {
          for (const key in this.leafForm.inputs) {
            let split = key.split('-');

            if (split[0] === 'undefined') {
              delete this.leafForm.inputs[key];
            }
          }
        } catch (error) {}
      }

      try {
        this.disables.splice(i, 1);
      } catch (error) {}

      this.leafForm.nLeaf--;
    },

    validateForm() {
      let passed = true;
      let amount_texture = 0;

      this.leafForm.lots_sel.forEach((lot_id) => {
        let count = 0;

        for (const key in this.leafForm.inputs) {
          let split = key.split('-');
          let index_nutrient = this.leafForm.nutrientColumns.findIndex(
            (column) => column.prop === Number(split[1])
          );

          if (split[0] == lot_id) {
            if (
              this.leafForm.inputs[key] != '' &&
              this.leafForm.inputs[key] != null
            ) {
              if (
                this.leafForm.nutrientColumns[index_nutrient].type == 'Textura'
              ) {
                amount_texture += parseFloat(this.groundForm.inputs[key]);
              }

              count++;
            }

            if (
              this.leafForm.inputs[key] != '' &&
              this.leafForm.inputs[key] != null &&
              parseFloat(this.leafForm.inputs[key]) == 0
            ) {
              count = 0;
              break;
            }
          }
        }

        if (count == 0) {
          passed = false;
        }
      });

      if (this.leafForm.nLeaf != this.leafForm.lots_sel.length) {
        return this.validationInputsRequired('lots');
      } else if (
        passed == false ||
        Object.keys(this.leafForm.inputs).length == 0
      ) {
        SweetAlert.warning(i18n.t('sweet_alert.leaf.inputed_leaf_capture'));
      } else if (amount_texture > 100) {
        SweetAlert.warning(i18n.t('sweet_alert.leaf.total_percentage_texture'));
        return this.validationInputsRequired('textures');
      } else {
        if (!this.validateArrayField('lots_sel')) {
          return this.validationInputsRequired('lots', true);
        } else {
          this.storeUpdateLeaf();
        }
      }
    },

    validateArrayField(field) {
      let passed = true;

      this.leafForm[field].forEach((elem) => {
        if (
          elem == null ||
          elem == '' ||
          (elem != '' && elem != null && parseFloat(elem) == 0) ||
          typeof elem == 'undefined'
        ) {
          passed = false;
        }
      });

      return passed;
    },

    storeUpdateLeaf() {
      this.showHideLoading(true);

      if (this.isCreate() || this.isUpdate()) {
        this.leafForm.route = 'leafs/leafs/store';
        Axios.saveMaster(this.leafForm)
          .then((response) => {
            this.leafForm.lots_sel_bck = Object.assign(
              [],
              this.leafForm.lots_sel
            );
            this.leafForm.inputs_bck = Object.assign({}, this.leafForm.inputs);
            this.old_lots_sel = Object.assign([], this.leafForm.lots_sel);

            if (typeof response.data.data.id !== 'undefined') {
              this.leafForm.id = response.data.id;
            }

            if (Object.keys(response.data.data.inputs_ids).length) {
              this.leafForm.inputs_ids = response.data.data.inputs_ids;
            }

            this.showHideLoading();
            this.showNotification(
              `${response.data.message}`,
              'success',
              'nc-simple-add',
              i18n.t('common_words.success_operation')
            );
          })
          .catch((error) => this.showMessageErrors(error));
      } else {
        this.showMessageAccess();
        this.showHideLoading();
      }
    },

    DeleteAll() {
      SweetAlert.delete(this.leafForm.date).then((result) => {
        if (result.value) {
          this.showHideLoading(true);
          if (this.leafForm.id && this.isDelete()) {
            this.leafForm.route = 'leafs/leafs';

            Axios.destroyMaster(this.leafForm)
              .then((response) => {
                this.cleanView();
                this.leafForm.nLeaf = 1;
                this.showHideLoading();
                this.showNotification(
                  `${response.data.message}`,
                  'success',
                  'nc-simple-remove',
                  i18n.t('common_words.successful_deletion')
                );
              })
              .catch((error) => this.showMessageErrors(error));
          } else {
            if (!this.isDelete()) {
              this.showMessageAccess();
            } else {
              this.showHideLoading();
            }
          }
        }
      });
    },

    handleExceed(files, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.ground.selected_limit')} ${
          files.length
        } ${i18n.t('sweet_alert.ground.files')}`
      );
    },

    handleSuccess(res, file) {
      if (res.errors) {
        let html = ``;
        res.errors.forEach((error) => {
          html += `<p> ${error} </p>`;
        });
        SweetAlert.danger(html);
      } else {
        this.generate();
      }

      this.$refs.upload.clearFiles();
      this.showHideLoading();
    },

    beforeUpload(file) {
      this.leafForm.date = moment(this.leafForm.date).format('YYYY-MM-DD');
    },

    submitUpload() {
      this.$refs.upload.submit();
    },

    downloadFormat() {
      let self = this;
      let data = self.leafForm;
      data.route = 'leafs/leafs/preformat';
      data.name_file = 'precarga_foliar.xlsx';
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
  },

  created() {
    this.showHideLoading(true);

    if (this.isCreate() || this.isUpdate()) {
      Axios.getMasters('farms/farms/only')
        .then((r) => {
          this.farms = r.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrorsSwalAlert(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('leafs');
  },

  destroyed() {
    this.deselectedItemOnMenu('leafs');
  },
};
</script>
<style>
.table-journals td:empty {
  visibility: hidden;
}

.table-journals td:blank {
  visibility: hidden;
}

.sticky-column {
  position: absolute;
  z-index: 100;
  /*height: 100%;*/
  background: #f8fcfe;
  box-shadow: 5px 0px 5px rgba(195, 209, 226, 0.2),
    0px -1px 0px rgba(195, 209, 226, 1);
}
</style>
